// Global alert manager for showing alerts from anywhere in the app
// This is used for callbacks from services like apiConfig

type AlertCallback = (message: string, onClick?: () => void) => void;

let ipRestrictionAlertCallback: AlertCallback | null = null;

export const setIpRestrictionAlertCallback = (callback: AlertCallback) => {
  ipRestrictionAlertCallback = callback;
};

export const getIpRestrictionAlertCallback = (): AlertCallback | null => {
  return ipRestrictionAlertCallback;
};